import React, { useCallback, useId } from 'react';
import PropTypes from 'prop-types';
import { Label, ButtonGroup, Button, Input } from 'reactstrap';
import classnames from 'classnames';
import { FieldError } from 'client/site-modules/shared/components/field-error/field-error';
import { TRANSMISSION_TYPE_INPUT } from 'client/site-modules/shared/utils/appraiser/appraiser-validation-helper';

const TRANSMISSION_TYPES = ['manual', 'automatic'];

const TransmissionTypeButton = ({ transmissionType, isSelected, onChange }) => {
  const uniqueId = `transmission-type-${transmissionType}`;
  const handleChange = useCallback(() => {
    onChange(transmissionType.toUpperCase());
  }, [onChange, transmissionType]);

  return (
    <Button
      key={uniqueId}
      tag={Label}
      htmlFor={uniqueId}
      outline={!isSelected}
      size="responsive"
      color={isSelected ? 'blue-50' : 'secondary'}
      className={classnames(
        'radio-group-button d-flex align-items-center justify-content-center fw-medium mb-0 py-0_25',
        {
          'btn-bg-white': !isSelected,
        }
      )}
    >
      <Input
        type="radio"
        id={uniqueId}
        name="transmission-type"
        value={transmissionType}
        onChange={handleChange}
        checked={isSelected}
        className="btn-check"
      />
      <span className="fw-normal text-capitalize">{transmissionType}</span>
    </Button>
  );
};

TransmissionTypeButton.propTypes = {
  transmissionType: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TransmissionTypeSelection = ({ selectedTransmissionType, onTransmissionTypeChange, errorMap }) => {
  const title = 'Transmission Type';
  const question = 'What type of transmission do you have?';
  const errorMessage = errorMap.get(TRANSMISSION_TYPE_INPUT);
  const errorId = `transmission-selector-error-${useId()}`;

  return (
    <div>
      <div className="text-gray-darker mb-0_5 fw-bold">{title}</div>
      <div className="transmission-selector question">
        <Label className="text-gray-darker mb-1">{question}</Label>
        <FieldError id={errorId} error={errorMessage} classes="mb-0_5" />
        <ButtonGroup className="d-flex" data-bs-toggle="buttons" role="radiogroup" aria-label={question}>
          {TRANSMISSION_TYPES.map(transmissionType => {
            const isSelected = transmissionType.toUpperCase() === selectedTransmissionType;

            return (
              <TransmissionTypeButton
                key={transmissionType}
                transmissionType={transmissionType}
                isSelected={isSelected}
                onChange={onTransmissionTypeChange}
              />
            );
          })}
        </ButtonGroup>
      </div>
    </div>
  );
};

TransmissionTypeSelection.propTypes = {
  selectedTransmissionType: PropTypes.string.isRequired,
  onTransmissionTypeChange: PropTypes.func.isRequired,
  errorMap: PropTypes.objectOf(PropTypes.string).isRequired,
};
